import PropTypes from 'prop-types'
import Tooltip from './Tooltip'

export default function LegalTooltip({ className = '' }) {
  const tooltipContent = `This calculator is provided for informational and illustrative purposes only. The calculations, estimates, and reward projections presented are based on hypothetical scenarios and assumptions, and do not guarantee future results. Actual savings or reward earnings may vary based on individual usage patterns, market conditions, vehicle costs, and program terms. This tool is not intended to provide financial, tax, or investment advice. Users should conduct their own due diligence and consult a qualified advisor before making financial decisions.`

  const legalButton = (
    <span 
      className={`text-sm underline cursor-help ${className}`}
      style={{ color: 'var(--Grays-Gray, #5D5D5D)' }}
    >
      For Illustrative Purposes Only
    </span>
  )

  const legalContent = (
    <div className="whitespace-pre-wrap leading-relaxed">
      {tooltipContent}
    </div>
  )

  return (
    <Tooltip button={legalButton} content={legalContent} />
  )
}

LegalTooltip.propTypes = {
  className: PropTypes.string,
} 